export enum SortTheatreType {
  Name = 'name',
  Created = 'created',
  Popularity = 'popularity',
}
